import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface CertificateItemProps {
  title: string
  date?: string | null
  isLocked?: boolean
  badgeSrcKey: string
}

export default function CertificateItem({ title, isLocked, badgeSrcKey }: CertificateItemProps): React.ReactElement {
  const titleClassName = title.length > 20 ? 'text-xxs' : 'text-xs'
  return (
    <div className="flex w-22 lg:w-36 flex-col items-center gap-2 opacity-90 hover:opacity-100 transition-opacity cursor-pointer">
      <div className={`w-20 h-14 flex items-center justify-center relative ${isLocked ? 'grayscale' : ''}`}>
        <ResponsiveImage
          alt="Certificate"
          fit="contain"
          height={1080}
          imageClassName="w-16 md:w-17"
          srcKey={badgeSrcKey}
          width={1080}
        />
      </div>
      <div className="flex flex-col items-center">
        <span className={`text-white ${titleClassName} font-bold text-center`}>{title}</span>
      </div>
    </div>
  )
}
